import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';

import { FileDropzoneDirective } from '../../../../../../shared/directives/file-dropzone/file-dropzone.directive';

/**
 * Bulk file dropzone for the CRL list view (REQ-5).
 *
 * Presentational shell around `FileDropzoneDirective`: it renders the desktop
 * drop bar (icon chip + copy + Browse Files) and the mobile full-width Upload
 * Files button, and drives its own visual states off the directive's `dragging`
 * signal and the `disabled` input. The directive owns all drag/picker mechanics
 * and emits validated files; this component only re-emits them. Real upload
 * wiring (AI categorization, DMS) lands in a later ticket.
 *
 * Browse Files carries no click handler of its own: its click reaches the host's,
 * which is what stops one click opening two pickers. The host stays a plain div
 * so the bar is a pointer convenience — Browse Files is the focusable, named
 * control, and a role here would nest a button inside a button.
 */
@Component({
  selector: 'cxp-crl-bulk-dropzone',
  templateUrl: './crl-bulk-dropzone.component.html',
  styleUrls: ['./crl-bulk-dropzone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, FileDropzoneDirective],
})
export class CrlBulkDropzoneComponent {
  readonly disabled = input<boolean>(false);
  readonly accept = input<string | string[]>('');
  readonly maxSize = input<number>(0);
  readonly multiple = input<boolean>(true);

  @Output() readonly filesSelected = new EventEmitter<File[]>();
  @Output() readonly filesRejected = new EventEmitter<string[]>();
}
